export default class FichesTechniques {
  constructor() {
    function fichesTechniques() {
      const formatsDOM = document.querySelectorAll(
        ".techniques-format-container"
      );
      var openFormat = document.querySelectorAll(".format-box");
      openFormat.forEach((f) => {
        f.addEventListener("click", (e) => {
          const formats = document.querySelectorAll(
            ".techniques-format-container"
          );
          formats.forEach((format) => {
            if (format.id == e.target.dataset.format) {
              format.style.display = "block";
            } else {
              format.style.display = "none";
            }
          });
        });
      });
    }
    fichesTechniques();

    function carouselShow(idFormat) {
      const id = document.getElementById(idFormat);
      const section = id.querySelector(".techniques-carousel");
      const slider = section.querySelector(".slider");

      const items = slider.querySelectorAll("img");
      const dotsNav = section.querySelector(".container-btn");
      const dots = Array.from(dotsNav.children);

      const moveToSlide = (currentSlide, targetSlide) => {
        currentSlide.classList.remove("active-slide");
        targetSlide.classList.add("active-slide");
      };
      dotsNav.addEventListener("click", (e) => {
        const targetDot = e.target.closest("button");
        if (!targetDot) return;
        const currentSlide = slider.querySelector(".active-slide");
        const currentDot = dotsNav.querySelector(".active-dot");
        const targetIndex = dots.findIndex((dot) => dot == targetDot);
        const targetSlide = items[targetIndex];
        moveToSlide(currentSlide, targetSlide);
        currentDot.classList.remove("active-dot");
        targetDot.classList.add("active-dot");
      });
    }
    carouselShow("open-1-6");
    carouselShow("open-1-4");
    carouselShow("open-1-3");
    carouselShow("open-1-2");
    carouselShow("open-1-p");
  }
}
